import React from 'react';
import { Heading2 } from '../atoms/Typography';
import StatusBadge from '../atoms/StatusBadge';
import MoreFunctions from '../atoms/MoreFunctions';

/**
 * Card header molecule — system title + status badge.
 */
export default function CardHeader({
  title,
  status,
  statusLabel,
  titleAsLink = false,
  onTitleClick,
  menuOptions = [],
  className = '',
}) {
  return (
    <div className={`ca-system-card__header ${className}`.trim()}>
      <div className="ca-system-card__title-wrap">
        {titleAsLink ? (
          <button
            type="button"
            className="ca-h2 ca-h2--link"
            onClick={onTitleClick}
          >
            {title}
          </button>
        ) : (
          <Heading2>{title}</Heading2>
        )}
      </div>
      <div className="ca-system-card__header-actions">
        <StatusBadge status={status} label={statusLabel} />
        <MoreFunctions options={menuOptions} />
      </div>
    </div>
  );
}
